// App.js
import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import FormularzStriegel from "./FormularzStriegel";
import "./style.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FormularzStriegel />} />
      </Routes>
    </Router>
  );
}

export default App;
